import { VALUE_TYPES } from "@/static/valueTypes";
import { Expose } from "class-transformer";
import { IsBoolean, IsEnum, IsNumber, IsOptional, IsString } from "class-validator";

export class NewContractorAttribute {
  @Expose()
  @IsString()
  name!: string;

  @Expose()
  @IsOptional()
  @IsString()
  defaultValue!: string | null;

  @Expose()
  @IsOptional()
  @IsNumber()
  attributePrototypeId!: number | null;

  @Expose()
  @IsEnum(VALUE_TYPES)
  valueType!: VALUE_TYPES;

  @Expose()
  @IsBoolean()
  isPrintable!: boolean;

  @Expose()
  @IsBoolean()
  isRequired!: boolean;

  @Expose()
  @IsOptional()
  @IsString()
  attributeSource!: null | string;

  constructor() {
    this.attributePrototypeId = null;
    this.name = "";
    this.defaultValue = "";
    this.valueType = VALUE_TYPES.String;
    this.isPrintable = false;
    this.isRequired = true;
    this.attributeSource = "";
  }
}
